// import { useEffect, useRef, useState } from "react";
// import { useUIService } from "../../../../../../../../../use-cases/ui";
// import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles";
// import readExcelFile from "read-excel-file";
// import { excelToJson } from "../../../../../../../../../utils";

// type FileUploadProps = {
//   label: string;
// };

// export const FileUpload: React.FC<FileUploadProps> = ({ label }) => {
//   const inputFileRef = useRef<HTMLInputElement>(null);
//   const [dragging, setDragging] = useState(false);
//     const abortControllerRef = useRef<AbortController | null>(null);
//   const { setLoading, setAlert } = useUIService();
//   const { setFile, openPreviewListaCidades, selectColumn, resetListaCidadesFileData} = useListaCidadesService();

//     useEffect(() => {
//     resetListaCidadesFileData();
    
//     // Cleanup no unmount
//     return () => {
//       if (abortControllerRef.current) {
//         abortControllerRef.current.abort();
//       }
//     };
//   }, []);

//   const processFileAndOpenDialog = async (fileData: any[], fileName: string, fileType: string, fileSize: string, columns: string[]) => {
    
//     // Verificar se os dados são válidos antes de enviar para o Redux
//     if (!fileData || fileData.length === 0) {
//       setAlert({
//         message: "Arquivo importado, mas não há dados válidos para processar.",
//         type: "error",
//       });
//       return;
//     }

//     if (!columns || columns.length === 0) {
//       setAlert({
//         message: "Arquivo não possui colunas válidas",
//         type: "error",
//       });
//       return;
//     }


//     // Atualizar o estado do Redux
//     setFile({
//       data: fileData,
//       name: fileName,
//       type: fileType,
//       size: fileSize,
//       columns: columns,
//     });
    
//     // Aguardar um pouco para o Redux processar e depois processar automaticamente
//     setTimeout(() => {
//       // Processar dados automaticamente (assumindo primeira coluna como padrão)
//       if (columns && columns.length > 0) {
//         selectColumn({
//           selectedColumn: columns[0],
//           data: fileData // Passar os dados diretamente para evitar dependência do Redux
//         }).then(() => {
//           // Abrir preview após processamento
//           setTimeout(() => {
//             openPreviewListaCidades(true);
//           }, 2000);
//         }).catch((error) => {
//           console.error('Erro no processamento:', error);
//           setAlert({
//             message: "Erro ao processar arquivo",
//             type: "error",
//           });
//         });
//       }
//     }, 500); // Aguardar 500ms para o Redux processar
//   };

//   const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragging(true);
//   };

//   const handleDragIn = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragging(true);
//   };

//   const handleDragOut = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragging(false);
//   };

//   const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragging(false);
//     if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
//       const loadingId = Math.random().toString();
//       setLoading({
//         id: loadingId,
//         loading: true,
//         message: "Lendo arquivo...",
//       });

//       const file = e.dataTransfer.files[0];
//       /* Check if is CSV or XLSX */
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         const fileType = file.type;
//         const fileName = file.name;
//         const fileSize = `${Math.round(file.size / 1024)} KB`;
//         const fileDataString = event.target?.result as string;
//         let fileData: any[] = [];
//         if (
//           file.type ===
//           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//         ) {
//           fileData = await readExcelFile(file, { sheet: 1 });
//           await processFileAndOpenDialog(
//             excelToJson(fileData),
//             fileName,
//             fileType,
//             fileSize,
//             fileData[0]
//           );

//         }
//         if (
//           file.type === "text/csv" ||
//           file.type === "text/plain" ||
//           file.type === "application/vnd.ms-excel"
//         ) {
//           const delimiter = guessDelimiter(fileDataString);
//           fileData = csvToJson(fileDataString, delimiter);
//           await processFileAndOpenDialog(
//             fileData,
//             fileName,
//             fileType,
//             fileSize,
//             fileDataString.split("\n")[0].split(delimiter)
//           );
//         }
//       };
//       reader.readAsText(file);
//       setLoading({
//         id: loadingId,
//         loading: false,
//       });
//     }
//   };
//   const guessDelimiter = (fileDataString: string) => {
//     const delimiters = [",", ";", "\t", "|"];
//     let maxCount = 0;
//     let maxDelimiter = ",";
//     delimiters.forEach((delimiter) => {
//       const count = fileDataString.split(delimiter).length;
//       if (count > maxCount) {
//         maxCount = count;
//         maxDelimiter = delimiter;
//       }
//     });
//     return maxDelimiter;
//   };

//   const csvToJson = (csvString: string, delimiter: string) => {
//     const rows = csvString.split("\n");
//     const result: any[] = [];
//     rows.slice(1, rows.length).forEach((item: any) => {
//       if (item !== "") {
//         const fields = item.split(delimiter);
//         let obj: any = {};
//         rows[0]?.split(delimiter).forEach((column: any, index: number) => {
//           obj[column] = fields[index];
//         });

//         result.push(obj);
//       }
//     });
//     return result;
//   };

//   return (
//     <div>
//       <div
//         className={`file-upload ${dragging ? "dragging" : ""}`}
//         onDragEnter={handleDragIn}
//         onDragLeave={handleDragOut}
//         onDragOver={handleDrag}
//         onDrop={handleDrop}
//         onClick={() => {
//           if (inputFileRef.current) {
//               inputFileRef.current.click()
//           }
//         }}
//       >
//         <div className="file-upload__label">{label}</div>
//         <input
//           hidden
//           type="file"
//           ref={inputFileRef}
//           onChange={async (e) => {
//             const file = e.target.files?.[0];
//             if (file) {
//               const loadingId = Math.random().toString();
//               setLoading({
//                 id: loadingId,
//                 loading: true,
//                 message: "Lendo arquivo...",
//               });

//               const reader = new FileReader();
//               reader.onload = async (event) => {
//                 const fileType = file.type;
//                 const fileName = file.name;
//                 const fileSize = `${Math.round(file.size / 1024)} KB`;
//                 const fileDataString = event.target?.result as string;
//                 let fileData: any[] = [];
//                 if (
//                   file.type ===
//                   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                 ) {
//                   fileData = await readExcelFile(file, { sheet: 1 });
//                   await processFileAndOpenDialog(
//                     excelToJson(fileData),
//                     fileName,
//                     fileType,
//                     fileSize,
//                     fileData[0]
//                   );
//                 }
//                 if (
//                   file.type === "text/csv" ||
//                   file.type === "text/plain" ||
//                   file.type === "application/vnd.ms-excel"
//                 ) {
//                   const delimiter = guessDelimiter(fileDataString);
//                   fileData = csvToJson(fileDataString, delimiter);

//                   await processFileAndOpenDialog(
//                     fileData,
//                     fileName,
//                     fileType,
//                     fileSize,
//                     fileDataString.split("\n")[0].split(delimiter)
//                   );
//                 }

//                 setLoading({
//                   id: loadingId,
//                   loading: false,
//                 });
//               };
//               reader.readAsText(file);
//             }
//           }}
//         />
//       </div>
//     </div>
//   );
// };


import { useEffect, useRef, useState } from "react";
import { useUIService } from "../../../../../../../../../use-cases/ui";
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles";
import readExcelFile from "read-excel-file";
import { excelToJson } from "../../../../../../../../../utils";

type FileUploadProps = {
  label: string;
};

export const FileUpload: React.FC<FileUploadProps> = ({ label }) => {
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);
  
  const { setLoading, setAlert } = useUIService();
  const { setFile, openPreviewListaCidades, selectColumn, resetListaCidadesFileData } = useListaCidadesService();

  useEffect(() => {
    // Reset completo quando o componente monta
    resetAllStates();
    
    return () => {
      // Cleanup no unmount
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  // Função para resetar todos os estados
  const resetAllStates = () => {
    // Cancelar qualquer operação em andamento
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    
    // Resetar estados locais
    setIsProcessing(false);
    setDragging(false);
    
    // Resetar dados do Redux
    resetListaCidadesFileData();
    
    // Limpar o input file para permitir novo upload do mesmo arquivo
    if (inputFileRef.current) {
      inputFileRef.current.value = '';
    }
  };

  const processFileAndOpenDialog = async (fileData: any[], fileName: string, fileType: string, fileSize: string, columns: string[]) => {
    // Verificar se foi cancelado
    if (abortControllerRef.current?.signal.aborted) {
      throw new Error("Operação cancelada");
    }
    
    // Verificar se os dados são válidos antes de enviar para o Redux
    if (!fileData || fileData.length === 0) {
      setAlert({
        message: "Arquivo importado, mas não há dados válidos para processar.",
        type: "error",
      });
      return;
    }

    if (!columns || columns.length === 0) {
      setAlert({
        message: "Arquivo não possui colunas válidas",
        type: "error",
      });
      return;
    }

    // Atualizar o estado do Redux
    setFile({
      data: fileData,
      name: fileName,
      type: fileType,
      size: fileSize,
      columns: columns,
    });
    
    // Aguardar um pouco para o Redux processar e depois processar automaticamente
    setTimeout(() => {
      // Verificar se foi cancelado antes de processar
      if (abortControllerRef.current?.signal.aborted) {
        return;
      }
      
      // Processar dados automaticamente (assumindo primeira coluna como padrão)
      if (columns && columns.length > 0) {
        selectColumn({
          selectedColumn: columns[0],
          data: fileData // Passar os dados diretamente para evitar dependência do Redux
        }).then(() => {
          // Verificar novamente se não foi cancelado
          if (!abortControllerRef.current?.signal.aborted) {
            // Abrir preview após processamento
            setTimeout(() => {
              if (!abortControllerRef.current?.signal.aborted) {
                openPreviewListaCidades(true);
              }
            }, 2000);
          }
        }).catch((error) => {
          console.error('Erro no processamento:', error);
          setAlert({
            message: "Erro ao processar arquivo",
            type: "error",
          });
        });
      }
    }, 500);
  };

  const handleFileUpload = async (file: File) => {
    // Se já está processando, não faz nada
    if (isProcessing) {
      return;
    }

    // Resetar antes de começar um novo upload
    resetAllStates();
    
    // Criar novo AbortController para esta operação
    abortControllerRef.current = new AbortController();
    setIsProcessing(true);
    
    const loadingId = Math.random().toString();
    setLoading({
      id: loadingId,
      loading: true,
      message: "Lendo arquivo...",
    });

    try {
      const reader = new FileReader();
      
      // Promise para encapsular o FileReader
      const fileReadPromise = new Promise((resolve, reject) => {
        reader.onload = async (event) => {
          try {
            if (abortControllerRef.current?.signal.aborted) {
              reject(new Error("Operação cancelada"));
              return;
            }
            
            const fileType = file.type;
            const fileName = file.name;
            const fileSize = `${Math.round(file.size / 1024)} KB`;
            const fileDataString = event.target?.result as string;
            let fileData: any[] = [];
            
            if (
              file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
              fileData = await readExcelFile(file, { sheet: 1 });
              await processFileAndOpenDialog(
                excelToJson(fileData),
                fileName,
                fileType,
                fileSize,
                fileData[0]
              );
            }
            
            if (
              file.type === "text/csv" ||
              file.type === "text/plain" ||
              file.type === "application/vnd.ms-excel"
            ) {
              const delimiter = guessDelimiter(fileDataString);
              fileData = csvToJson(fileDataString, delimiter);
              
              await processFileAndOpenDialog(
                fileData,
                fileName,
                fileType,
                fileSize,
                fileDataString.split("\n")[0].split(delimiter)
              );
            }
            
            resolve(true);
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = () => reject(new Error("Erro ao ler arquivo"));
      });
      
      reader.readAsText(file);
      
      // Aguardar a leitura do arquivo com possibilidade de cancelamento
      await Promise.race([
        fileReadPromise,
        new Promise((_, reject) => {
          if (abortControllerRef.current) {
            abortControllerRef.current.signal.addEventListener('abort', () => {
              reader.abort();
              reject(new Error("Operação cancelada"));
            });
          }
        })
      ]);
      
    } catch (error) {
      if (error instanceof Error && error.message === "Operação cancelada") {
        setAlert({
          message: "Upload cancelado",
          type: "info",
        });
      } else {
        console.error("Erro no upload:", error);
        setAlert({
          message: "Erro ao processar arquivo",
          type: "error",
        });
      }
    } finally {
      setLoading({
        id: loadingId,
        loading: false,
      });
      setIsProcessing(false);
      // Não resetar o abortController aqui para evitar race conditions
    }
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isProcessing) {
      setDragging(true);
    }
  };

  const handleDragIn = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isProcessing) {
      setDragging(true);
    }
  };

  const handleDragOut = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0 && !isProcessing) {
      const file = e.dataTransfer.files[0];
      handleFileUpload(file);
    }
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && !isProcessing) {
      await handleFileUpload(file);
    }
  };

  const guessDelimiter = (fileDataString: string) => {
    const delimiters = [",", ";", "\t", "|"];
    let maxCount = 0;
    let maxDelimiter = ",";
    delimiters.forEach((delimiter) => {
      const count = fileDataString.split(delimiter).length;
      if (count > maxCount) {
        maxCount = count;
        maxDelimiter = delimiter;
      }
    });
    return maxDelimiter;
  };

  const csvToJson = (csvString: string, delimiter: string) => {
    const rows = csvString.split("\n");
    const result: any[] = [];
    rows.slice(1, rows.length).forEach((item: any) => {
      if (item !== "") {
        const fields = item.split(delimiter);
        let obj: any = {};
        rows[0]?.split(delimiter).forEach((column: any, index: number) => {
          obj[column] = fields[index];
        });
        result.push(obj);
      }
    });
    return result;
  };

  const handleCancel = () => {
    resetAllStates();
    setAlert({
      message: "Upload cancelado",
      type: "info",
    });
  };

  return (
    <div>
      <div
        className={`file-upload ${dragging ? "dragging" : ""} ${isProcessing ? "processing" : ""}`}
        onDragEnter={handleDragIn}
        onDragLeave={handleDragOut}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={() => {
          if (inputFileRef.current && !isProcessing) {
            inputFileRef.current.click();
          }
        }}
        style={{
          cursor: isProcessing ? 'not-allowed' : 'pointer',
          opacity: isProcessing ? 0.6 : 1
        }}
      >
        <div className="file-upload__label">
          {isProcessing ? "Processando arquivo..." : label}
        </div>
        <input
          hidden
          type="file"
          ref={inputFileRef}
          onChange={handleInputChange}
          accept=".xlsx,.csv,.xls"
        />
      </div>
      
      {isProcessing }
    </div>
  );
};
